import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Homepage from './pages/Homepage';
import Calculator from './pages/Calculator';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import QuoteRequest from './pages/QuoteRequest';
import Solutions from './pages/Solutions';
import Portfolio from './pages/Portfolio';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';
import VisitTracker from './components/VisitTracker';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App">
            <VisitTracker />
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/magazin" element={<Shop />} />
              <Route path="/produs/:productId" element={<ProductDetail />} />
              <Route path="/cos" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/servicii" element={<Services />} />
              <Route path="/serviciu/:serviceId" element={<ServiceDetail />} />
              <Route path="/vreau-oferta" element={<QuoteRequest />} />
              <Route path="/solutii" element={<Solutions />} />
              <Route path="/portofoliu" element={<Portfolio />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
